export enum BgColors {
    Primary = 'bgColor_primary',
    Secondary = 'bgColor_secondary',
    Accent = 'bgColor_accent',
    Danger = 'bgColor_danger',
    Warning = 'bgColor_warning',
    Safe = 'bgColor_safe',
    Black = 'bgColor_black',
    Gray  = 'bgColor_gray',
    White = 'bgColor_white',
    Link = 'bgColor_link',
    Body = 'bgColor_body',
    Action = 'bgColor_action',
    Border = 'bgColor_border',
    Overlay = 'bgColor_overlay',
    Modal = 'bgColor_modal',
    Hidden = 'bgColor_hidden',
}